import { RESET_STATE } from 'store/global/actions';

import { TPO_SIGNUP_CONFIGURATIONS_ACTION_TYPE } from '../actions';

const initialState = {
  list: [],
};

const tpoSignupConfigurationsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case TPO_SIGNUP_CONFIGURATIONS_ACTION_TYPE.GET_LIST:
      return { ...state, list: Array.isArray(payload) ? payload : [] };

    case TPO_SIGNUP_CONFIGURATIONS_ACTION_TYPE.CREATE:
      return { ...state, list: [...state.list, payload] };

    case TPO_SIGNUP_CONFIGURATIONS_ACTION_TYPE.UPDATE:
      return {
        ...state,
        list: state.list.map(config =>
          config.tpoSignupConfigurationId === payload.tpoSignupConfigurationId ? payload : config,
        ),
      };

    case TPO_SIGNUP_CONFIGURATIONS_ACTION_TYPE.DELETE:
      return {
        ...state,
        list: state.list.filter(config => config.tpoSignupConfigurationId !== payload.id),
      };

    case TPO_SIGNUP_CONFIGURATIONS_ACTION_TYPE.SET_DEFAULT:
      return {
        ...state,
        list: state.list.map(config => ({
          ...config,
          isDefault: config.tpoSignupConfigurationId === payload.id,
        })),
      };

    case RESET_STATE:
      return initialState;

    default:
      return state;
  }
};

export default tpoSignupConfigurationsReducer;
